import { gql } from '@apollo/client';

export const SUBMIT_ALL_WORKSPACE_SUBMISSION = gql`
  mutation SubmitAllWorkspaceFormSubmission($id: ID!) {
    workspaceFormSubmission: submitAllWorkspaceFormSubmission(id: $id) {
      id
      status
    }
  }
`;
